__turbopack_context__.v({
  "creation": "character-page-module__i4TSmW__creation",
  "creationTitle": "character-page-module__i4TSmW__creationTitle",
  "message": "character-page-module__i4TSmW__message",
  "saveIndicator": "character-page-module__i4TSmW__saveIndicator",
  "saveIndicatorError": "character-page-module__i4TSmW__saveIndicatorError",
  "saveIndicatorIcon": "character-page-module__i4TSmW__saveIndicatorIcon",
  "saveIndicatorVisible": "character-page-module__i4TSmW__saveIndicatorVisible",
  "workspace": "character-page-module__i4TSmW__workspace",
});
